<a class="santa-flex santa-items-center santa-whitespace-nowrap" [routerLink]="['/']" [class.full]="full">
  <alliance-icon class="logo small" [name]="LogoHelper.name" [width]="state.width"></alliance-icon>
  <alliance-icon class="logo large" [name]="LogoHelperLong.name" [width]="240"></alliance-icon>
</a>
